import { Data, Effect } from 'effect';
import { okraApi } from '../okraApi';
import type { FileListResponse, FileListQuery } from '../types';

export class FilesEndpointError extends Data.TaggedError('FilesEndpointError')<{
  readonly operation: 'list-url';
}> {}

const filesEndpointCauses = new WeakMap<FilesEndpointError, unknown>();

function filesEndpointFailure(cause: unknown): FilesEndpointError {
  const error = new FilesEndpointError({ operation: 'list-url' });
  filesEndpointCauses.set(error, cause);
  return error;
}

export function filesEndpointErrorCause(error: FilesEndpointError): unknown {
  return filesEndpointCauses.get(error);
}

export const filesListUrlEffect = Effect.fn('web.api.files.listUrl')(function* (
  params: FileListQuery | void,
) {
  return yield* Effect.try({
    try: () => {
      const search = new URLSearchParams();
      search.set('purpose', params?.purpose ?? 'asset');
      search.set('limit', String(params?.limit ?? 100));
      if (params?.q?.trim()) search.set('q', params.q.trim());
      if (params?.cursor) search.set('cursor', params.cursor);
      return `/v1/files?${search.toString()}`;
    },
    catch: filesEndpointFailure,
  });
});

function filesListUrl(params: FileListQuery | void): string {
  return Effect.runSync(filesListUrlEffect(params).pipe(Effect.orDie));
}

export const filesEndpoints = okraApi.injectEndpoints({
  endpoints: (build) => ({
    listFiles: build.query<FileListResponse, FileListQuery | void>({
      query: (params) => filesListUrl(params),
      providesTags: ['Files'],
    }),
  }),
});

export const {
  useListFilesQuery,
} = filesEndpoints;
